var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoPendingClaim(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 88,
    viewBox: "0 0 89 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1568"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M88.7939 0H0V88H88.7939V0Z",
    fill: "url(#paint0_linear_9640_23043)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M88.8547 0H24.6997V61.8676H88.8547V0Z",
    fill: "url(#paint1_linear_9640_23043)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.6904 17.3357H68.5121C68.3052 17.3357 68.107 17.2537 67.9607 17.1074C67.8144 16.9612 67.7324 16.7628 67.7324 16.5561C67.7324 15.3036 67.7324 12.8574 67.7324 11.605C67.7324 11.3982 67.8144 11.1999 67.9607 11.0536C68.107 10.9073 68.3052 10.8253 68.5121 10.8253H72.6904V6.64684C72.6904 6.44008 72.7726 6.24173 72.9187 6.09563C73.0649 5.94936 73.2633 5.86719 73.47 5.86719H78.4213C78.6281 5.86719 78.8264 5.94936 78.9725 6.09563C79.1188 6.24173 79.201 6.44008 79.201 6.64684V10.8253H83.3793C83.586 10.8253 83.7844 10.9073 83.9307 11.0536C84.0768 11.1999 84.1589 11.3982 84.1589 11.605V16.5561C84.1589 16.7628 84.0768 16.9612 83.9307 17.1074C83.7844 17.2537 83.586 17.3357 83.3793 17.3357C81.9832 17.3357 79.201 17.3357 79.201 17.3357V21.5142C79.201 21.721 79.1188 21.9193 78.9725 22.0654C78.8264 22.2117 78.6281 22.2939 78.4213 22.2939C77.1687 22.2939 74.7225 22.2939 73.47 22.2939C73.2633 22.2939 73.0649 22.2117 72.9187 22.0654C72.7726 21.9193 72.6904 21.721 72.6904 21.5142C72.6904 20.1182 72.6904 17.3357 72.6904 17.3357Z",
    fill: "url(#paint2_linear_9640_23043)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M53.9873 13.9595C54.669 14.4653 55.6475 14.8501 56.9779 15.136C58.2313 15.4108 58.8361 15.7187 59.1219 15.9276C59.3088 16.0595 59.4188 16.2245 59.4188 16.6203C59.4188 16.8732 59.3638 17.159 58.957 17.4889C58.5612 17.8077 57.9894 17.9727 57.2528 17.9727C56.4611 17.9727 55.8454 17.7967 55.4496 17.4559C55.1527 17.203 55.0098 16.9501 54.9988 16.6203C54.9658 16.0156 54.4051 15.5538 53.8443 15.5868C53.2396 15.6197 52.7778 16.1365 52.8108 16.7522C52.8658 17.6978 53.2726 18.5004 54.0422 19.1491C54.603 19.6219 55.3067 19.9298 56.1203 20.0727V21.1942C56.1203 21.7989 56.6151 22.2937 57.2198 22.2937C57.8245 22.2937 58.3193 21.7989 58.3193 21.1942V20.0947C59.1109 19.9628 59.8036 19.6659 60.3644 19.2151C61.2 18.5334 61.6288 17.6648 61.6288 16.6423C61.6288 15.6197 61.222 14.7621 60.4413 14.1904C59.7706 13.6846 58.7921 13.2998 57.4507 13.0139C56.1863 12.7391 55.5925 12.4312 55.3067 12.2223C55.1307 12.0903 55.0098 11.9254 55.0098 11.5296C55.0098 11.2767 55.0648 10.9909 55.4716 10.661C55.8674 10.3421 56.4391 10.1772 57.1648 10.1772C57.9565 10.1772 58.5722 10.3531 58.968 10.694C59.2649 10.9469 59.3968 11.1998 59.4188 11.5296C59.4518 12.1343 59.9685 12.6181 60.5843 12.5631C61.189 12.5301 61.6508 12.0024 61.6178 11.3977C61.5628 10.4521 61.145 9.64946 60.3863 9.01175C59.8256 8.53897 59.1219 8.24211 58.3083 8.08818V6.96669C58.3083 6.36196 57.8135 5.86719 57.2088 5.86719C56.6041 5.86719 56.1093 6.36196 56.1093 6.96669V8.06618C55.3177 8.19812 54.625 8.49499 54.0642 8.94578C53.2176 9.63847 52.7998 10.4961 52.7998 11.5186C52.7998 12.5411 53.2066 13.3988 53.9873 13.9705V13.9595Z",
    fill: "url(#paint3_linear_9640_23043)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M36.8672 29.5195H15.8154V30.6956H36.8672V29.5195Z",
    fill: "url(#paint4_linear_9640_23043)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M36.8672 22.5234H15.8154V23.6995H36.8672V22.5234Z",
    fill: "url(#paint5_linear_9640_23043)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M27.2278 15.5234H15.8198V16.6995H27.2278V15.5234Z",
    fill: "url(#paint6_linear_9640_23043)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M11.9341 15.5234H9.34668V16.6995H11.9341V15.5234Z",
    fill: "url(#paint7_linear_9640_23043)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M11.9341 22.5234H9.34668V23.6995H11.9341V22.5234Z",
    fill: "url(#paint8_linear_9640_23043)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M11.9341 29.5195H9.34668V30.6956H11.9341V29.5195Z",
    fill: "url(#paint9_linear_9640_23043)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M11.9341 36.457H9.34668V37.6331H11.9341V36.457Z",
    fill: "url(#paint10_linear_9640_23043)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M11.9341 43.457H9.34668V44.6331H11.9341V43.457Z",
    fill: "url(#paint11_linear_9640_23043)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M11.9341 50.3945H9.34668V51.5706H11.9341V50.3945Z",
    fill: "url(#paint12_linear_9640_23043)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M11.9341 57.3945H9.34668V58.5706H11.9341V57.3945Z",
    fill: "url(#paint13_linear_9640_23043)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M11.9341 64.3867H9.34668V65.5628H11.9341V64.3867Z",
    fill: "url(#paint14_linear_9640_23043)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M11.9341 71.3281H9.34668V72.5042H11.9341V71.3281Z",
    fill: "url(#paint15_linear_9640_23043)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M77.1506 50.3945H41.2803V51.5706H77.1506V50.3945Z",
    fill: "url(#paint16_linear_9640_23043)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M37.2788 50.3945H15.8154V51.5706H37.2788V50.3945Z",
    fill: "url(#paint17_linear_9640_23043)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M80.5627 57.3945H50.0435V58.5706H80.5627V57.3945Z",
    fill: "url(#paint18_linear_9640_23043)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M46.1031 57.3945H27.2271V58.5706H46.1031V57.3945Z",
    fill: "url(#paint19_linear_9640_23043)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M68.7426 64.3867H27.2271V65.5628H68.7426V64.3867Z",
    fill: "url(#paint20_linear_9640_23043)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M55.8021 71.3281H38.6313V72.5042H55.8021V71.3281Z",
    fill: "url(#paint21_linear_9640_23043)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M48.7467 36.457H29.0474V37.6331H48.7467V36.457Z",
    fill: "url(#paint22_linear_9640_23043)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M48.7467 43.457H29.0474V44.6331H48.7467V43.457Z",
    fill: "url(#paint23_linear_9640_23043)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9640_23043",
    x1: 0.284885,
    y1: 37.8459,
    x2: 88.5685,
    y2: 68.144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CADCF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9640_23043",
    x1: 24.9055,
    y1: 26.6072,
    x2: 88.3166,
    y2: 48.9721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CADCF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9640_23043",
    x1: 51.1324,
    y1: 23.792,
    x2: 84.3324,
    y2: 23.792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9640_23043",
    x1: 43.8776,
    y1: 23.7918,
    x2: 61.722,
    y2: 23.7918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_9640_23043",
    x1: 15.8154,
    y1: 30.1076,
    x2: 36.8672,
    y2: 30.1076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_9640_23043",
    x1: 15.8154,
    y1: 23.1115,
    x2: 36.8672,
    y2: 23.1115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_9640_23043",
    x1: 15.8198,
    y1: 16.1115,
    x2: 27.2278,
    y2: 16.1115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_9640_23043",
    x1: 9.34668,
    y1: 16.1115,
    x2: 11.9341,
    y2: 16.1115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_9640_23043",
    x1: 9.34668,
    y1: 23.1115,
    x2: 11.9341,
    y2: 23.1115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_9640_23043",
    x1: 9.34668,
    y1: 30.1076,
    x2: 11.9341,
    y2: 30.1076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_9640_23043",
    x1: 9.34668,
    y1: 37.0451,
    x2: 11.9341,
    y2: 37.0451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_9640_23043",
    x1: 9.34668,
    y1: 44.0451,
    x2: 11.9341,
    y2: 44.0451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_9640_23043",
    x1: 9.34668,
    y1: 50.9826,
    x2: 11.9341,
    y2: 50.9826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_9640_23043",
    x1: 9.34668,
    y1: 57.9826,
    x2: 11.9341,
    y2: 57.9826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_9640_23043",
    x1: 9.34668,
    y1: 64.9748,
    x2: 11.9341,
    y2: 64.9748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_9640_23043",
    x1: 9.34668,
    y1: 71.9162,
    x2: 11.9341,
    y2: 71.9162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_9640_23043",
    x1: 41.2803,
    y1: 50.9826,
    x2: 77.1506,
    y2: 50.9826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_9640_23043",
    x1: 15.8154,
    y1: 50.9826,
    x2: 37.2788,
    y2: 50.9826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_9640_23043",
    x1: 50.0435,
    y1: 57.9826,
    x2: 80.5627,
    y2: 57.9826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_9640_23043",
    x1: 27.2271,
    y1: 57.9826,
    x2: 46.1031,
    y2: 57.9826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_9640_23043",
    x1: 27.2271,
    y1: 64.9748,
    x2: 68.7426,
    y2: 64.9748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_9640_23043",
    x1: 38.6313,
    y1: 71.9162,
    x2: 55.8021,
    y2: 71.9162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_9640_23043",
    x1: 29.0474,
    y1: 37.0451,
    x2: 48.7467,
    y2: 37.0451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_9640_23043",
    x1: 29.0474,
    y1: 44.0451,
    x2: 48.7467,
    y2: 44.0451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPendingClaim);
export default __webpack_public_path__ + "static/media/noPendingClaim.924ec07c8a5c48ea31c8098b0938126b.svg";
export { ForwardRef as ReactComponent };